// extracted by mini-css-extract-plugin
export default {"mt":"MoveModal_mt__tltH5"};